export const BUSINESS_TYPE = ['นิติบุคล', 'บุคคลธรรมดา'];
export const CUSTOMER_TYPE = ['ลูกค้า', 'คู่ค้า', 'ลูกค้า/คู่ค้า'];
